// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"139":"category","353":"contact","369":"galery","480":"impressum","594":"about"}[chunkId] + "." + {"139":"c40bc203","353":"5124d377","369":"45457ded","480":"1b1a62ec","594":"eecc7b95"}[chunkId] + ".css";
};